export enum QueueType {
  RepeatAll = 'RepeatAll',
  RepeatOne = 'RepeatOne',
  ShuffleEach = 'ShuffleEach',
}

// upon fire response, these queue types will automatically move to another pitch (next for repeat all, random for shuffle)
export const AUTO_ADVANCE_QUEUE_TYPES = [
  QueueType.RepeatAll,
  QueueType.ShuffleEach,
];

export interface IQueueDefinition {
  type: QueueType;
  label: string;
  tooltip: string;
  icon: JSX.Element;
}

export interface IQueueOptions {
  action: 'add' | 'remove';
  id: string;
}
